// Creators are 18+ (docs/build/creator-age.md). The services refuse creator actions for 13-17 accounts with
// 403 `creator_age`; the dashboard (claim a game, claim a handle, assets, earnings, per-game pages) shows this kind
// note instead of the actions. Players' pages are unchanged.

export const CREATOR_AGE = "creator_age";

/** True when this account may use the creator dashboard. */
export function creatorAllowed(me: { ageBand: string } | null): boolean {
  return me?.ageBand === "18+";
}

/** The note for 13-17 accounts (plain text, so tests can read it). Without selling (wave 9) it skips earnings and tips. */
export function creatorAgeCopy(selling: boolean) {
  return {
    title: "Creating on Banger starts at 18",
    lead: selling ? "Claiming games, publishing assets and creator earnings need an 18+ account." : "Claiming games and publishing assets need an 18+ account.",
    later: "Yours opens on its own on your 18th birthday. There's nothing to fill in: just sign in that day.",
    meanwhile: selling
      ? "Until then, everything for players is yours: play, follow creators, tip the games you love and join their communities."
      : "Until then, everything for players is yours: play, follow creators and join their communities.",
  };
}

/** The note while coins are sold. */
export const CREATOR_AGE_COPY = creatorAgeCopy(true);

/** What a page says for an API `creator_age` refusal. */
export const CREATOR_AGE_ERROR = "Creator features need an 18+ account. They open on your 18th birthday.";
